import { StoreState } from '../store-interfaces';

export const selectVoyagerFilterAttributes = (state: StoreState) =>
  state.voyagerLeads.attributes;

export const selectVoyagerLeads = (state: StoreState) =>
  state.voyagerLeads.contacts.records;

export const selectVoyagerLeadsCount = (state: StoreState) =>
  state.voyagerLeads.contacts.total;
